"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _nano = require("./nano");
var _variables = require("./variables");
var headerStyles = {
  applicationHeader: {
    position: 'fixed',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    height: _variables.headerHeight,
    width: '100%',
    zIndex: _variables.zIndexes.get('header')
  },
  linkBlock: {
    position: 'relative',
    height: '100%',
    div: {
      height: '100%'
    },
    a: {
      height: '100%',
      padding: '8px',
      textDecoration: 'none',
      boxSizing: 'border-box'
    }
  }
};
var _default = exports["default"] = (0, _nano.sheet)(headerStyles);